import logUnsampledDatapoint from './logUnsampledDatapoint';
import SmartPillData from '../store/schema/SmartPillData';

/**
 * This method will be used in the future, once new scorecards are created for the datapoint schema
 */
export default function logOnRenderDatapoint(
    itemsShown: SmartPillData[],
    itemsHidden: SmartPillData[],
    arbitratorId: string
): void {
    // If any pill has cosmosOnlyData, remove it from the logData.
    // cosmosOnlyData is intended to log a single value, so for now, just take the data
    // from the first pill that has it.
    let cosmosOnlyData: string = undefined;
    const allPills: SmartPillData[] = itemsShown.concat(itemsHidden);

    allPills.forEach(i => {
        if (!cosmosOnlyData && i.logData.cosmosOnlyData) {
            cosmosOnlyData = i.logData.cosmosOnlyData;
        }
    });

    const itemsShownObj = {
        data: itemsShown.map(i => i.logData.mainPayload),
    };

    const itemsHiddenObj = {
        data: itemsHidden.map(i => i.logData.mainPayload),
    };

    logUnsampledDatapoint(
        'SmartPillsRendered',
        [
            itemsShown.length,
            itemsHidden.length,
            JSON.stringify(itemsShownObj),
            JSON.stringify(itemsHiddenObj),
            arbitratorId,
        ],
        cosmosOnlyData
    );
}

/**
 * Needed temporarily so that existing smart reply scorecards don't break
 * Datapoint must be backward compatible with old implementation's
 * @param extractionID GUID from stamped property.
 * @param loggableSmartReplies Raw smart replies (left to right).
 * @param featureNames Types of pills we are rendering (e.g. SmartReply, SmartTime, etc)
 * @param hiddenPills Pills we processed but didn't render.
 * @param language: The language of the message, for experimentation.
 * @param locale: The locale of the message, for experimentation.
 * @param internetMessageId: IMI, requested by FocusedInbox team.
 */
export function logOnRenderDatapointLegacy(
    extractionID: string,
    loggableSmartReplies: string[],
    featureNames: string[],
    hiddenPills: string[],
    language: string,
    locale: string,
    internetMessageId: string
): void {
    logUnsampledDatapoint(
        'SmartReply_Rendered',
        [
            extractionID,
            false /* counterfactual [deprecated] */,
            loggableSmartReplies.join('$'), // same delimiter as jsMVVM
            false /* isItemPart [deprecated] */,
            featureNames.toString(),
            hiddenPills.toString(),
            language,
            locale,
        ],
        internetMessageId // cosmosOnlyData
    );
}
